import REQ from '../../utils/REQ';
import { PageBase } from '@components/page/base';

/**
 * @package
 */
export const PageNotFound = () => {
  return <PageBase req={REQ.NOT_FOUND} />;
};
